import React, { useContext, useEffect, useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'gatsby'
import { StoreContext } from '../../context/store-context'
import CrossIcon from '../../icons/cross'
import HamburgerIcon from '../../icons/hamburger'
import Logo from '../../icons/logo'
import { CartButton } from '../cart/CartButton/CartButton'
import { CartSlideout } from '../cart/CartSlideout/CartSlideout'
import { DropdownIcon } from '../navigation/Dropdown'
import SearchNav from '../navigation/Search'

const TopNav = ({ mobileActive, onUpdate }) => {
  const { checkout } = useContext(StoreContext)

  const items = checkout ? checkout.lineItems : []

  const quantity = items.reduce((total, item) => {
    return total + item.quantity
  }, 0)

  const [showCart, setShowCart] = useState(false)

  return (
    <div className='mega-top-nav'>
      <Link
        className='main-logo grid-item d-block d-lg-none'
        to='/'
        aria-label='RubberFlooring4U'
      >
        <Logo />
      </Link>
      <div className='mega-menu position-relative'>
        <Col className='bars-col' xs={3}>
          <Link
            className='main-logo grid-item d-none d-lg-block'
            to='/'
            aria-label='RubberFlooring4U'
          >
            <Logo />
          </Link>
          {!mobileActive ? (
            <div
              className='menu-bars grid-item'
              onClick={() => {
                onUpdate(true)
              }}
            >
              <HamburgerIcon />
            </div>
          ) : (
            <div
              to='#'
              className='menu-bars'
              onClick={() => {
                onUpdate(false)
              }}
            >
              <CrossIcon className='cross-icon' />
            </div>
          )}
        </Col>
        <Col>
          <SearchNav />
        </Col>
        <Col xs={3}>
          <Row className='mega-desktop-icons m-auto'>
            <Col className='d-none d-lg-block phone-icon'>
              <DropdownIcon />
            </Col>
            <Col>
              <CartButton
                quantity={quantity}
                onClick={() => {
                  setShowCart(true)
                }}
              />
              <div
                onClick={() => setShowCart(false)}
                style={{ top: '-10px' }}
                className={`overlay position-fixed ${showCart ? 'active' : ''}`}
              ></div>
              <CartSlideout showCart={showCart} setShowCart={setShowCart} />
            </Col>
          </Row>
        </Col>
      </div>
    </div>
  )
}

export default TopNav
